import React, { useState } from "react";
import {
  FiHome,
  FiBarChart2,
  FiClock,
  FiUsers,
  FiCheckCircle,
  FiSettings,
  FiHelpCircle,
  FiSearch,
  FiBell,
  FiMenu,
  FiX,
  FiDownload,
  FiFilter,
  FiChevronDown,
} from "react-icons/fi";

const Navbar = ({ onToggleSidebar }) => {
  return (
    <>
      <header className="main-navbar">
        <div className="main-navbar-left">
          <button className="main-menu-toggle" onClick={onToggleSidebar}>
            <FiMenu size={20} />
          </button>

          <div className="main-search-container">
            <FiSearch className="main-search-icon" size={18} />
            <input
              type="text"
              placeholder="Search framework..."
              className="main-search-input"
            />
          </div>
        </div>

        <div className="main-navbar-right">
          <button className="main-icon-btn">
            <div className="main-icon-wrapper">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
              </svg>
            </div>
          </button>

          <button className="main-icon-btn">
            <div className="main-icon-wrapper main-dark-mode">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>
            </div>
          </button>

          <button className="main-icon-btn main-notification-btn">
            <FiBell size={20} />
            <span className="main-notification-dot"></span>
          </button>

          <div className="main-profile-menu">
            <img
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face"
              alt="Profile"
              className="main-profile-avatar"
            />
          </div>
        </div>
      </header>

      <style jsx>{`
        .main-navbar {
          height: 70px;
          background: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 1.5rem 0 1rem;
          position: sticky;
          top: 0;
          z-index: 100;
          margin: 0;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        }

        .main-navbar-left {
          display: flex;
          align-items: center;
        }

        .main-menu-toggle {
          display: none;
          background: none;
          border: none;
          padding: 0.5rem;
          color: #64748b;
          cursor: pointer;
          border-radius: 6px;
          transition: background 0.2s ease;
          margin-right: 1rem;
        }

        .main-menu-toggle:hover {
          background: #f1f5f9;
        }

        .main-search-container {
          position: relative;
          width: 300px;
        }

        .main-search-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #64748b;
        }

        .main-search-input {
          width: 100%;
          padding: 0.75rem 1rem 0.75rem 2.75rem;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 0.875rem;
          background: #f8fafc;
          transition: all 0.2s ease;
        }

        .main-search-input:focus {
          outline: none;
          border-color: #3b82f6;
          background: white;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .main-search-input::placeholder {
          color: #94a3b8;
        }

        .main-navbar-right {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .main-icon-btn {
          background: none;
          border: none;
          padding: 0.5rem;
          color: #64748b;
          cursor: pointer;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }

        .main-icon-btn:hover {
          background: #f1f5f9;
          color: #374151;
        }

        .main-icon-wrapper {
          padding: 0.5rem;
          background: #f1f5f9;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }

        .main-icon-wrapper:hover {
          background: #e2e8f0;
        }

        .main-icon-wrapper.main-dark-mode {
          background: #1e293b;
          color: white;
        }

        .main-icon-wrapper.main-dark-mode:hover {
          background: #334155;
        }

        .main-notification-btn {
          position: relative;
        }

        .main-notification-dot {
          position: absolute;
          top: 0.25rem;
          right: 0.25rem;
          width: 8px;
          height: 8px;
          background: #ef4444;
          border-radius: 50%;
          border: 2px solid white;
          animation: main-pulse 2s infinite;
        }

        .main-profile-menu {
          cursor: pointer;
          transition: transform 0.2s ease;
        }

        .main-profile-menu:hover {
          transform: translateY(-1px);
        }

        .main-profile-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #e2e8f0;
          transition: border-color 0.2s ease;
        }

        .main-profile-avatar:hover {
          border-color: #3b82f6;
        }

        @keyframes main-pulse {
          0% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.7;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        /* Responsive Design */
        @media (max-width: 1023px) {
          .main-menu-toggle {
            display: block;
          }

          .main-search-container {
            width: 200px;
          }
        }

        @media (max-width: 768px) {
          .main-navbar {
            padding: 0 1rem;
          }

          .main-menu-toggle {
            display: block;
          }

          .main-search-container {
            display: none;
          }

          .main-navbar-right {
            gap: 0.5rem;
          }

          .main-icon-btn {
            padding: 0.375rem;
          }

          .main-icon-wrapper {
            padding: 0.375rem;
          }

          .main-profile-avatar {
            width: 32px;
            height: 32px;
          }
        }

        @media (max-width: 480px) {
          .main-navbar {
            padding: 0 0.75rem;
          }

          .main-navbar-right {
            gap: 0.25rem;
          }

          .main-icon-btn {
            padding: 0.25rem;
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;
